import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { SscButtonComponent, SscButtonHierarchy, SscEmptyPlaceholderComponent } from '@marineform/ssc-ui';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-not-found',
  imports: [
    IonicModule,
    RouterLink,
    SscButtonComponent,
    SscEmptyPlaceholderComponent,
    TranslocoPipe,
  ],
  template: `
    <ion-content class="ion-padding">
      <div class="flex flex-col items-center justify-center min-h-full">
        <ssc-empty-placeholder
          title="errors|not-found|title"
          message="errors|not-found|message"
          icon="smiley-melting">
          <a
            ssc-button
            [routerLink]="rootLink"
            [hierarchy]="buttonHierarchy.primary">
            {{ 'errors|not-found|home' | transloco }}
          </a>
        </ssc-empty-placeholder>
      </div>
    </ion-content>
  `,
})
export class NotFoundPageComponent {
  readonly rootLink = '/';
  readonly buttonHierarchy = SscButtonHierarchy;
}
